import { DistributorListType, FundManager, Trustee } from './api-types';

export const GET_FUNDS_LIST = 'GET_FUNDS_LIST';
export const GET_FUNDS_LIST_SUCCESS = 'GET_FUNDS_LIST_SUCCESS';

export const EXPORT_FUNDS = 'EXPORT_FUNDS';
export const EXPORT_FUNDS_SUCCESS = 'EXPORT_FUNDS_SUCCESS';

export const ADD_FUND = 'ADD_FUND';
export const ADD_FUND_SUCCESS = 'ADD_FUND_SUCCESS';

export const ADD_PLAN = 'ADD_PLAN';
export const ADD_PLAN_SUCCESS = 'ADD_PLAN_SUCCESS';

export const UPDATE_PLAN = 'UPDATE_PLAN';
export const UPDATE_PLAN_SUCCESS = 'UPDATE_PLAN_SUCCESS';

export const GET_FUNDS_ACCESS = 'GET_FUNDS_ACCESS';
export const GET_FUNDS_ACCESS_SUCCESS = 'GET_FUNDS_ACCESS_SUCCESS';

export const GET_FREEZE_ACCESS = 'GET_FREEZE_ACCESS';
export const GET_FREEZE_ACCESS_SUCCESS = 'GET_FREEZE_ACCESS_SUCCESS';

export const UPDATE_FUND = 'UPDATE_FUND';
export const UPDATE_FUND_SUCCESS = 'UPDATE_FUND_SUCCESS';

export const UPDATE_FREEZE = 'UPDATE_FREEZE';
export const UPDATE_FREEZE_SUCCESS = 'UPDATE_FREEZE_SUCCESS';

export const GET_PLAN = 'GET_PLAN';
export const GET_PLAN_SUCCESS = 'GET_PLAN_SUCCESS';

export const GET_PLAN_DETAILS = 'GET_PLAN_DETAILS';
export const GET_PLAN_DETAILS_SUCCESS = 'GET_PLAN_DETAILS_SUCCESS';

export type GetFundsListResponseBody = {
  funds: FundProps[];
};

export type FundProps = {
  amcId: number;
  schemeCode: string;
  schemeName: string;
  amcCode: string;
  bankName: string;
  bankBranch: string;
  ifscCode: string;
  bankAccountNumber: string;
  isActive: boolean;
  freezeStatus: boolean;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
  plans: ClassPlanProps[];
  id: string;
  CVL_PWD: string;
  CVL_PASSCODE: string;
  CVL_USERNAME: string;
  CVL_APP_POS_CODE: string;
  CVL_ENABLE_NEW_API: boolean | null;
  CVL_JSON_AES_KEY: string | null;
  CVL_JSON_API_KEY: string | null;
  LEEGALITY_STAMP_SERIES: string;
  LEEGALITY_STAMP_SERIES_GROUP: string;
  LEEGALITY_STAMP_VALUE: number | null;
  LEEGALITY_USE_STAMP_SERIES: boolean | null;
  indMinNetworth: number | null;
  nonIndMinNetworth: number | null;
  [key: string]: string | number | boolean | ClassPlanProps[] | undefined | null;
};

export type accessType = {
  fundSetupAccess: boolean;
};
export type FundManagerDetails = {
  fundmanagerIds: string[] | number[] | null;
  fundmanagers: FundManager[] | null;
};

export type freezeAccessType = {
  schemeFreezeAccess: boolean;
};

export type TrusteeDetails = {
  trusteeIds: string[] | number[] | null;
  trustees: Trustee[] | null;
};
export type addFundType = {
  bankAccountNumber: string;
  schemeCode: string;
  schemeName: string;
  amcCode: string;
  bankName: string;
  bankBranch: string;
  ifscCode: string;
  CVL_PWD: string;
  CVL_PASSCODE: string;
  CVL_USERNAME: string;
  CVL_APP_POS_CODE: string;
  CVL_ENABLE_NEW_API: boolean | null;
  CVL_JSON_AES_KEY: string | null;
  CVL_JSON_API_KEY: string | null;
  LEEGALITY_STAMP_SERIES: string;
  LEEGALITY_STAMP_SERIES_GROUP: string;
  LEEGALITY_STAMP_VALUE: number | null;
  LEEGALITY_USE_STAMP_SERIES: boolean | null;
  indMinNetworth: number | null;
  nonIndMinNetworth: number | null;
};

export type addSetupFee = {
  fee: number | null;
  isActive: boolean;
};

export type addPlanType = {
  schemeId: number | string | null;
  planCode: string;
  planDescription: string;
  schemeNature: string;
  registrationNumber: string;
  schemeCategory: string;
  country: string;
  currency: string;
  schemeStartDate: string;
  lockInPeriod: string;
  lockInExtension: string;
  inActive: boolean;
  faceValue: number | null;
  fundAddress1: string;
  fundAddress2: string;
  fundAddress3: string;
  isActive: boolean;
  custodian: string;
  setupFee: number | null;
  fundManagerId?: number | null;
  trusteeId?: number | null;
  fundmanagerIds: string[] | number[] | null;
  trusteeIds: string[] | number[] | null;
  fundmanagerDetails?: FundManagerDetails;
  trusteeDetails?: TrusteeDetails;
  requiredFundManagers?: number | null;
  requiredTrustees?: number | null;
  minCommitmentAmount: number | null;
  maxCommitmentAmount: number | null;
  minContributionPercentage: number | null;
  managementFee: number | null;
  placementFeeApplicable: string | null;
  placementFee: number | null;
  operatingExpensesApplicable: string | null;
  operatingExpenses: string | null;
  offeringExpenses?: number | null;
  tcLink: string;
  distributorIds: string[] | number[] | null;
  isApplicableForDirect: boolean;
  setupFeeValues: addSetupFee[] | number[];
  setupFeeApplicable: string;
  netCommitmentAmtApplicable: string;
  equalisationAmtApplicable: string;
  equalisationAmtType: string | null;
  minEqualisationAmt: number | null;
  maxEqualisationAmt: number | null;
  defaultEqualisationAmt: number | null;
  equalisationPercentApplicable: string;
  equalisationPercentValues: addSetupFee[] | number[];
};

export type addFundPlanType = {
  schemeCode: string;
  schemeName: string;
  amcCode: string;
  bankName: string;
  bankBranch: string;
  ifscCode: string;
  bankAccountNumber: string;
  id: string;
  schemeId: number | null;
  planCode: string;
  planDescription: string;
  schemeNature: string;
  registrationNumber: string;
  schemeCategory: string;
  country: string;
  currency: string;
  schemeStartDate: string;
  lockInPeriod: string;
  lockInExtension: string;
  inActive: boolean;
  faceValue: number | null;
  fundAddress1: string;
  fundAddress2: string;
  fundAddress3: string;
  isActive: boolean;
  custodian: string;
  setupFee: number | null;
  fundManagerId?: number | null;
  trusteeId?: number | null;
  fundmanagerIds: string[] | number[] | null;
  trusteeIds: string[] | number[] | null;
  fundmanagerDetails?: FundManagerDetails;
  trusteeDetails?: TrusteeDetails;
  requiredFundManagers?: number | null;
  requiredTrustees?: number | null;
  minCommitmentAmount: number | null;
  maxCommitmentAmount: number | null;
  minContributionPercentage: number | null;
  managementFee: number | null;
  placementFeeApplicable: string | null;
  placementFee: number | null;
  operatingExpensesApplicable: string | null;
  operatingExpenses: string | null;
  tcLink: string;
  offeringExpenses: number | null;
  distributorIds: string[] | number[] | null;
  isApplicableForDirect: boolean;
  setupFeeValues: addSetupFee[] | number[];
  equalisationPercentApplicable: string;
  equalisationPercentValues: addSetupFee[] | number[];
  setupFeeApplicable: string;
  netCommitmentAmtApplicable: string;
  equalisationAmtApplicable: string;
  equalisationAmtType: string | null;
  minEqualisationAmt: number | null;
  maxEqualisationAmt: number | null;
  defaultEqualisationAmt: number | null;
  CVL_PWD: string;
  CVL_PASSCODE: string;
  CVL_USERNAME: string;
  CVL_APP_POS_CODE: string;
  CVL_ENABLE_NEW_API: boolean | null;
  CVL_JSON_AES_KEY: string | null;
  CVL_JSON_API_KEY: string | null;
  LEEGALITY_STAMP_SERIES: string;
  LEEGALITY_STAMP_SERIES_GROUP: string;
  LEEGALITY_STAMP_VALUE: number | null;
  LEEGALITY_USE_STAMP_SERIES: boolean | null;
  indMinNetworth: number | null;
  nonIndMinNetworth: number | null;
};

export type DistributorDetailsInPlans = {
  distributorIds: string[] | number[];
  distributors: DistributorListType[];
};
export type ClassPlanProps = {
  id: string;
  schemeId: any;
  planCode: string;
  fundManagerId?: number | null;
  trusteeId?: number | null;
  fundmanagerIds: string[] | number[] | null;
  trusteeIds: string[] | number[] | null;
  fundmanagerDetails?: FundManagerDetails;
  trusteeDetails?: TrusteeDetails;
  requiredFundManagers?: number | null;
  requiredTrustees?: number | null;
  planDescription: string;
  schemeNature: string;
  registrationNumber: string;
  schemeCategory: string;
  country: string;
  fundManager: FundManager;
  trustee: Trustee;
  currency: string;
  schemeStartDate: string;
  lockInPeriod: string;
  lockInExtension: string;
  inActive: boolean;
  faceValue: number | null;
  fundAddress1: string;
  fundAddress2: string;
  fundAddress3: string;
  custodian: string;
  setupFee: number | null;
  minCommitmentAmount: number;
  maxCommitmentAmount: number;
  minContributionPercentage: number;
  managementFee: number | null;
  placementFeeApplicable: string | null;
  placementFee: number | null;
  operatingExpensesApplicable: string | null;
  operatingExpenses: string | null;
  offeringExpenses: number | null;
  isActive: boolean;
  tcLink: string;
  createdBy: number | null;
  createdAt: string;
  updatedAt: string;
  distributorDetails: DistributorDetailsInPlans;
  distributorIds: string[] | number[] | null;
  isApplicableForDirect: boolean;
  setupFeeValues: addSetupFee[] | number[];
  setupFeeApplicable: string;
  netCommitmentAmtApplicable: string;
  equalisationAmtApplicable: string;
  equalisationAmtType: string | null;
  minEqualisationAmt: number | null;
  maxEqualisationAmt: number | null;
  defaultEqualisationAmt: number | null;
  equalisationPercentValues: addSetupFee[] | number[];
  equalisationPercentApplicable: string;
};

export const GET_FUNDS_SUCCESS = 'GET_FUNDS_SUCCESS';
export const GET_FUNDS = 'GET_FUNDS';

export const GET_DIRECTAPPLICABLEFUNDS_SUCCESS = 'GET_DIRECTAPPLICABLEFUNDS_SUCCESS';
export const GET_DIRECTAPPLICABLEFUNDS = 'GET_DIRECTAPPLICABLEFUNDS';

export type distType = {
  distributorId: string;
};

export const GET_DIST_SUCCESS = 'GET_DIST_SUCCESS';
export const GET_DIST = 'GET_DIST';

export const GET_FUND_DRAFTS = 'GET_FUND_DRAFTS';
export const GET_FUND_DRAFTS_SUCCESS = 'GET_FUND_DRAFTS_SUCCESS';
export const GET_FUND_DRAFT = 'GET_FUND_DRAFT';
export const GET_FUND_DRAFT_SUCCESS = 'GET_FUND_DRAFT_SUCCESS';
export const SAVE_FUND_DRAFT_STEP = 'SAVE_FUND_DRAFT_STEP';
export const SAVE_FUND_DRAFT_STEP_SUCCESS = 'SAVE_FUND_DRAFT_STEP_SUCCESS';
export const SUBMIT_FUND_DRAFT = 'SUBMIT_FUND_DRAFT';
export const SUBMIT_FUND_DRAFT_SUCCESS = 'SUBMIT_FUND_DRAFT_SUCCESS';

export type FundDraftStatus = 'DRAFT' | 'COMPLETED';

export type FundDraftStepData = Record<string, unknown>;

export type FundDraft = {
  id: string;
  step1Data: FundDraftStepData | null;
  step2Data: FundDraftStepData | null;
  step3Data: FundDraftStepData | null;
  currentStep: number;
  status: FundDraftStatus;
  schemeId: string | null;
  planId: string | null;
  createdBy: string;
  updatedBy: string | number;
  createdAt: string;
  updatedAt: string;
};

export type SaveFundDraftStepBody = {
  draftId?: string;
  currentStep: number;
  data: FundDraftStepData;
};

export type SubmitFundDraftResponse = {
  draft: FundDraft;
  scheme?: FundProps;
  plan?: ClassPlanProps;
};
